import {
    AddAdminMasterEmployee,
    deleteAdminMasterEmployee,
    getAdminMasterEmployee,
    getMasterEmployee
} from 'data/MasterEmployee/repositories/MasterEmployee.repository';
import {
    AdminMasterEmployeeResponse,
    MasterEmployeeRequest,
    WorkflowAdminReqeust
} from 'data/MasterEmployee/schemas/MasterEmployee.shema';
import useLoader from 'hooks/useLoader';
import { parseJwt } from 'modules/Common';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { useHistory, useLocation } from 'react-router-dom';

function WorkflowConfigAdminViewModel() {
    useEffect(() => {
        var ls: any = localStorage.getItem('WF_APPLICATION');
        var jls: any = JSON.parse(ls);
        var access_token = parseJwt(jls.access_token);
        var extra = JSON.parse(access_token.extra);

        setUserAdmin(extra.citizen_id);

        fetchUserAdminMasterEmployee();
        fetchUserMasterEmployee();
    }, []);

    const location = useLocation();
    const history = useHistory();

    const loading = useLoader();
    const [userAdminResponse, setUserAdminResponse] =
        useState<AdminMasterEmployeeResponse[]>();

    const [userMasterEmployee, setUserMasterEmployee] =
        useState<MasterEmployeeRequest[]>();

    const [userAdmin, setUserAdmin] = useState<string>('');
    const [searchHelp, setSearchHelp] = useState<WorkflowAdminReqeust>({
        userID: '',
        company: '',
        employeeName: '',
        roleAccess: ''
    });

    const [selectdAllCompany, setSelectdAllCompany] = useState<boolean>(true);

    const fetchUserAdminMasterEmployee = async () => {
        if (searchHelp.company === '' && !selectdAllCompany) {
            Swal.fire({
                icon: 'info',
                title: 'Please choose',
                text: 'กรุณาเลือก Company'
            });

            return;
        }
        try {
            loading.show();
            const [_, response] = await getAdminMasterEmployee(searchHelp);

            if (response) {
                setUserAdminResponse(response);
            }
        } finally {
            loading.hide();
        }
    };

    const fetchUserMasterEmployee = async () => {
        try {
            loading.show();
            const [_, response] = await getMasterEmployee();

            if (response) {
                setUserMasterEmployee(response.result_list);
            }
        } finally {
            loading.hide();
        }
    };

    const handleAddUserAdmin = async (
        sid: string,
        role: string,
        employee: string
    ) => {
        await createUserAdminMasterEmployee(employee, userAdmin, sid, role);
        // const options: { [key: string]: string } = {};
        // userMasterEmployee &&
        //     userMasterEmployee!.forEach(value => {
        //         options[value.email!] = `${value.id} (${value.email})`;
        //     });
        // Swal.fire({
        //     title: 'กรุณาเลือก User',
        //     input: 'select',
        //     inputOptions: options,
        //     inputValidator: value => {
        //         return new Promise(resolve => {
        //             if (!value) {
        //                 resolve('กรุณาเลือก User');
        //             } else {
        //                 resolve(undefined!);
        //             }
        //         });
        //     },
        //     allowOutsideClick: false,
        //     showCloseButton: true,
        //     showCancelButton: true,
        //     confirmButtonText: 'Add',
        //     customClass: {
        //         container: 'z-[9999]',
        //         confirmButton:
        //             'bg-[#FFFF] border-[#28a745] hover:bg-[#28a745] hover:text-[#FFFF] text-[#28a745]',
        //         cancelButton:
        //             'bg-[#FFFF] border-[#dc3545] hover:bg-[#dc3545] hover:text-[#FFFF] text-[#dc3545]',
        //         input: 'border rounded-lg p-2'
        //     }
        // }).then((result: SweetAlertResult<string>) => {
        //     if (result.isConfirmed) {
        //         // createUserAdminMasterEmployee(result.value!, userAdmin);
        //     }
        // });
    };

    const createUserAdminMasterEmployee = async (
        user: string,
        createBy: string,
        sid: string,
        roleAccess: string
    ) => {
        try {
            loading.show();
            const [_, response] = await AddAdminMasterEmployee({
                user: user,
                createBy: createBy,
                sid: sid,
                roleAccess: roleAccess
            });

            if (response.message === 'success') {
                Swal.fire({
                    title: 'Success',
                    text: `เพิ่ม User: ${user} เป็น ${roleAccess} แล้ว`,
                    icon: 'success'
                }).then(result => {
                    if (result.isConfirmed) {
                        fetchUserAdminMasterEmployee();
                        history.push({ pathname: location.pathname });
                    }
                });
            }
        } catch (error) {
            const _ = Swal.fire({
                title: 'Error',
                text: `User: ${user} เป็น ${roleAccess} อยู่แล้ว`,
                icon: 'error'
            });
        } finally {
            loading.hide();
            fetchUserAdminMasterEmployee();
        }
    };

    const deleteUserAdminMasterEmployee = async (
        user: AdminMasterEmployeeResponse
    ) => {
        try {
            loading.show();
            const [_, response] = await deleteAdminMasterEmployee({
                sid: user.sid,
                userId: user.id,
                roleAccess: user.role_access
            });
            if (response.message === 'success') {
                Swal.fire({
                    title: 'Success',
                    text: `ลบ User: ${user.id} Role: ${user.role_access} แล้ว`,
                    icon: 'success'
                }).then(result => {
                    if (result.isConfirmed) {
                        fetchUserAdminMasterEmployee();
                    }
                });
            }
        } finally {
            loading.hide();
        }
    };

    const handleDeleteAdminMasterEmployee = async (
        user: AdminMasterEmployeeResponse
    ) => {
        Swal.fire({
            title: 'คุณต้องการลบ',
            text: `User: ${user.id} Role: ${user.role_access} ใช่หรือไม่`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'yes'
        }).then(result => {
            if (result.isConfirmed) {
                deleteUserAdminMasterEmployee(user);
            }
        });
    };

    const handleChangeSearchHelp = <K extends keyof WorkflowAdminReqeust>(
        key: K,
        value: WorkflowAdminReqeust[K]
    ) => {
        setSearchHelp(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    return {
        selectdAllCompany,
        userAdminResponse,
        userMasterEmployee,
        handleAddUserAdmin,
        setSelectdAllCompany,
        handleChangeSearchHelp,
        fetchUserAdminMasterEmployee,
        handleDeleteAdminMasterEmployee
    };
}

export default WorkflowConfigAdminViewModel;
